import { create } from 'zustand';

import { BuyStepName } from '@/utils/constants/digital-gold';

export type BuyRedirectionType = {
  buyStep: string;
  setBuyStep: (buyStep: string) => void;
};
// const initialData : BuyRedirectionType = {
//     buyStep : 'landing',
// }

export const useBuyRedirectStore = create<BuyRedirectionType>((set) => ({
  buyStep: BuyStepName.buyLanding,
  setBuyStep: (buyStep) => set(() => ({ buyStep })),
}));
